export default __webpack_public_path__ + "static/media/user-profile.b1820907.png";